import styles from "./EditScreenSampleFontSquare.module.css";

import sample_font from "../../assets/images/edit_screen/WoodenPlateSquare/sample_font.png";

const EditScreenSampleFontSquare = ({ title, subtitle }) => {
  return (
    <div>
      <div className={styles.main}>
        <div className={styles.header_section}>
          <div name={title} className={styles.sample_section1_header}>
            {title}
          </div>
          <div className={styles.sample_section1_subtitle}>{subtitle}</div>
        </div>
        <div className={styles.font_main}>
          <img className={styles.font_image} src={sample_font} alt="fonts" />
        </div>
      </div>
    </div>
  );
};
export default EditScreenSampleFontSquare;
